import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ListFilter } from "admin/appModel/Filter";
import { Observable } from "rxjs";


@Injectable()
export class AppService
{
    constructor(
        protected http: HttpClient) { }

    GetTemplates(filter: ListFilter): Observable<void> {
        return this.http.post<any>("/Templates/GetTemplates", filter);
    }
}